import _ from 'lodash';

export const getDocumentRoutingName = (documentType: string) =>
  _.cond<string, string>([
    [_.curry(_.eq)('Tilstandsvurdering bygning'), _.constant('tilstand')],
    [_.curry(_.eq)('Avvik'), _.constant('avvik')],
    [_.curry(_.eq)('Bygningsarbeid'), _.constant('work')],
  ])(documentType);
